import { queryOptions, useQuery } from '@tanstack/react-query';

import { storeCatalogApi } from '../api/store-catalog-api';

import { storeCatalogKeys } from './store-catalog-keys';

export function storeProductQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: storeCatalogKeys.detail(storeId, id),
    queryFn: () => storeCatalogApi.get(storeId, id),
  });
}

export function useStoreProduct(storeId: string, id: string) {
  return useQuery(storeProductQueryOptions(storeId, id));
}
